

import React, { useState, useEffect } from "react";
import "../AddPermission/AddPermission.css";
import { Permission, User, UserPostModel } from "../../Items/User";
import { getAllPermissions } from "../../Services/UserService";
import permissionIconOff from '../../assets/images/Permissions_Page_Chack_Box_Off.png'
import permissionIconOn from '../../assets/images/Permissions_Page_Chack_Box_On.png'


interface AddPermissionProps {
  setShowUserForm: () => void;
  onSave: (user: UserPostModel) => void | Promise<void>;
  user?: User; // זה מה שמוצג בעריכה
}

const AddPermission: React.FC<AddPermissionProps> = ({ setShowUserForm, onSave, user }) => {
  const [formData, setFormData] = useState<UserPostModel>({
    fullName: "",
    phone: "",
    email: "",
    passwordHash: "",
    selectedPermissionIds: []
  });

  const [allPermissions, setAllPermissions] = useState<Permission[]>([]);

  useEffect(() => {
    // מביא את כל ההרשאות מהשרת
    getAllPermissions().then(perms => setAllPermissions(perms));
  }, []);

  useEffect(() => {
    if (user) {
      setFormData({
        fullName: user.fullName,
        phone: user.phone,
        email: user.email,
        passwordHash: user.passwordHash,
        selectedPermissionIds: user.permissions.map(p => p.id) // המרה לאיידי של הרשאות
      });
    }
  }, [user]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, checked } = e.target;

    if (name === "selectedPermissionIds") {
      const permId = parseInt(value);
      setFormData(prev => ({
        ...prev,
        selectedPermissionIds: checked
          ? [...prev.selectedPermissionIds, permId]
          : prev.selectedPermissionIds.filter(p => p !== permId)
      }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSave = () => {
    console.log("Saving user with permissions:", formData.selectedPermissionIds);
    onSave(formData);
  };

  return (
    <div className="user-form">
      <div className="form-row">
        <label className="lblBold">שם מלא -</label>
        <input type="text" name="fullName" value={formData.fullName} onChange={handleChange} />

        <label className="lblBold">טלפון -</label>
        <input type="text" name="phone" value={formData.phone} onChange={handleChange} />

        <label className="lblBold">אימייל -</label>
        <input type="email" name="email" value={formData.email} onChange={handleChange} />

        <label className="lblBold">סיסמה -</label>
        <input type="password" name="passwordHash" value={formData.passwordHash} onChange={handleChange} />
      </div>

      <div className="form-row">
        <label className="lblBold">בחר הרשאות:</label>
        {/* {allPermissions.map(perm => (
          <label key={perm.id}>
            <input
              type="checkbox"
              name="selectedPermissionIds"
              value={perm.id}
              checked={formData.selectedPermissionIds.includes(perm.id)}
              onChange={handleChange}
            />
            {perm.name}
          </label>
        ))} */}
        {allPermissions.map(perm => (
  <label key={perm.id} className="custom-radio">
    <input
      type="checkbox"
      name="selectedPermissionIds"
      value={perm.id}
      checked={formData.selectedPermissionIds.includes(perm.id)}
      onChange={() =>
        setFormData(prev => ({
          ...prev,
          selectedPermissionIds: prev.selectedPermissionIds.includes(perm.id)
            ? prev.selectedPermissionIds.filter(id => id !== perm.id)
            : [...prev.selectedPermissionIds, perm.id]
        }))
      }
      hidden
    />
    <img
      src={
        formData.selectedPermissionIds.includes(perm.id)
          ? permissionIconOn
          : permissionIconOff
      }
      alt="checkbox option"
      className="checkbox-image"
    />
    {perm.name}
  </label>
))}

      </div>

      <div className="form-actions">
        <button className="save-btn" onClick={handleSave}>שמור</button>
        <button className="cancel-btn" onClick={setShowUserForm}>ביטול</button>
      </div>
    </div>
  );
};

export default AddPermission;
